<template>
  <div class="main">
    <div class="bg">
      <img src="../assets/poker/bg2.png" />
    </div>
    <div class="card--body">
      <div class="ipoker">I-POKER</div>
      <div class="export" v-if="active_report" @click="exportClick">
        <b-icon icon="download"></b-icon>&nbsp;匯出
      </div>
      <div class="form-box" v-show="active_add">
        <b-form @submit="onSubmit" @reset="onReset">
          <div class="add-game">
            <b-form-group label="類別：" label-for="radio-button">
              <div class="tabs" id="radio-button">
                <div class="tabs-title">
                  <div id="tab-name-form-cash" class="tab-item" @click="clickTab('cash')">現金桌</div>
                  <div id="tab-name-form-mtt" class="tab-item" @click="clickTab('mtt')">錦標賽</div>
                </div>
              </div>
            </b-form-group>
            <b-form-group id="input-group-cash" label="買入：" label-for="input-cash" required>
              <b-form-input
                class="g-width"
                id="input-cash"
                v-model="form.cashIn"
                placeholder="必填"
                required
                type="number"
                inputmode="numeric"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-2"
              :label="form.type === 'cash' ? '出金：' : '獎金：'"
              label-for="input-2"
              required
            >
              <b-form-input
                class="g-width"
                id="input-2"
                v-model="form.cashOut"
                placeholder="必填"
                required
                type="number"
                inputmode="numeric"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-3" label="名稱：" label-for="input-3">
              <b-form-input
                class="g-width"
                id="input-3"
                v-model="form.name"
                placeholder="選填"
                type="text"
                :state="nameState ? undefined : false"
                aria-describedby="input-live-help input-live-feedback"
              ></b-form-input>
              <b-form-invalid-feedback id="input-live-feedback">名稱過長(上限16)</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group id="input-group-4" label="備註：" label-for="input-4">
              <b-form-input
                class="g-width"
                id="input-4"
                v-model="form.comment"
                placeholder="選填"
                type="text"
                :state="commentState ? undefined : false"
                aria-describedby="input-live-help input-live-feedback1"
              ></b-form-input>
              <b-form-invalid-feedback id="input-live-feedback1">備註字數過多(上限200)</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="date">
            <label for="example-datepicker">時間：</label>
            <b-form-datepicker
              id="example-datepicker"
              :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
              v-model="form.date"
              class="mb-2 g-width"
              dropright
            ></b-form-datepicker>
          </div>
          <b-button class="save-btn" type="submit" variant="success">儲存紀錄</b-button>
        </b-form>
      </div>
      <div class="report" v-show="active_report">
        <div class="report-content">
          <div class="report-item" style="margin-top: 20px">
            <div class="title">類別：</div>
            <div class="report-tabs">
              <div class="tabs-title">
                <div id="tab-name-report-all" class="tab-item" @click="clickTabReport('all')">總體</div>
                <div id="tab-name-report-cash" class="tab-item" @click="clickTabReport('cash')">現金桌</div>
                <div id="tab-name-report-mtt" class="tab-item" @click="clickTabReport('mtt')">錦標賽</div>
              </div>
            </div>
          </div>
          <hr />
          <div class="no-list" v-if="list.length === 0">目前沒有任何紀錄哦</div>
          <div class="no-list" v-else-if="showList.length === 0">選取範圍無資料！</div>
          <div v-else>
            <div class="report-item">
              <div class="title">盈利：</div>
              <div class="result" :style="report_result.profit >= 0 ? 'color:red' : 'color:green'">
                ${{ report_result.profit > 0 ? "+" : ""
                }}{{ report_result.profit.toLocaleString("en-US") }}
              </div>
            </div>
            <hr />
            <div class="report-item">
              <div class="title">贏率：</div>
              <div class="result">
                {{
                report_result.winCount +
                "/" +
                report_result.games +
                "(" +
                report_result.winRatio +
                "%)"
                }}
              </div>
            </div>
            <hr />
            <div class="report-item">
              <div class="title">$/牌局：</div>
              <div
                class="result"
                :style="
                  report_result.gainPerGame >= 0 ? 'color:red' : 'color:green'
                "
              >
                ${{ report_result.gainPerGame > 0 ? "+" : ""
                }}{{ report_result.gainPerGame.toLocaleString("en-US") }}
              </div>
            </div>
            <hr />
            <div class="report-item">
              <div class="title">投資報酬率：</div>
              <div
                class="result"
                :style="
                  report_result.gainPerGame >= 0 ? 'color:red' : 'color:green'
                "
              >{{ report_result.ROI.toLocaleString("en-US") }}%</div>
            </div>
            <hr />
            <div class="report-item">
              <div class="title">投入資金：</div>
              <div class="result">${{ report_result.spend.toLocaleString("en-US") }}</div>
            </div>
            <hr />
            <div class="report-item">
              <div class="title">累積獎金：</div>
              <div
                class="result"
                style="color: peru"
              >${{ report_result.gain.toLocaleString("en-US") }}</div>
            </div>
          </div>
        </div>
        <template v-if="list.length">
          <hr />
          <div class="select-range" v-if="selfSet">
            <b-form-datepicker
              :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
              v-model="filter.startDate"
              placeholder="開始日期"
              size="sm"
              @input="clickTabReport(report_tab)"
            ></b-form-datepicker>&nbsp;~&nbsp;
            <b-form-datepicker
              class="end-date"
              :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
              v-model="filter.endDate"
              placeholder="結束日期"
              size="sm"
              dropright
              dropdown
              @input="clickTabReport(report_tab)"
            ></b-form-datepicker>
            <b-icon
              icon="backspace-fill"
              style="margin-left: 8px"
              aria-hidden="true"
              @click="resetRange"
            ></b-icon>
          </div>
          <div class="hot-key" v-else>
            <b-button id="btn-all" class="hot-key-btn" size="sm" @click="timeBtnClick('all')">全部</b-button>
            <b-button id="btn-6m" class="hot-key-btn" size="sm" @click="timeBtnClick('6m')">近半年</b-button>
            <b-button id="btn-3m" class="hot-key-btn" size="sm" @click="timeBtnClick('3m')">近三個月</b-button>
            <b-button
              id="btn-set"
              class="hot-key-btn"
              size="sm"
              :style="(filter.startDate == '' || filter.endDate == '')?'':'padding:0px'"
              @click="dateModalShow = true"
            >
              <div v-if="filter.startDate == '' || filter.endDate == ''">自訂</div>
              <div class="hot-key-btn-set" v-else>
                <div>{{filter.startDate}}</div>
                <div>{{filter.endDate}}</div>
              </div>
            </b-button>
          </div>
        </template>
        <!-- <div class="showDate" v-if="showDate">{{filter.startDate}}~{{filter.endDate}}</div> -->
        <template v-if="showList.length === 0 && list.length">
          <!-- <div class="warn-range">選取範圍無資料！</div> -->
        </template>
        <template v-else>
          <div class="list-region">
            <b-row
              class="cus-row"
              align-v="center"
              v-for="(item, index) in showList"
              :key="index"
              :style="index % 2 === 1 ? 'background-color:#ebe0cd75' : ''"
              @click="showComment(index)"
            >
              <b-col cols="3" class="col-date text-left p-1">
                <b-icon
                  font-scale="1.2"
                  :style="
                        item.type === 'mtt' ? 'color: steelblue' : 'color: peru'
                      "
                  :icon="
                        item.type === 'mtt' ? 'stopwatch' : 'coin'
                      "
                ></b-icon>
                {{
                item.date
                }}
              </b-col>
              <b-col cols="5" class="col-comment p-1">{{ item.name }}</b-col>
              <b-col
                cols="3"
                class="col-profit text-right p-1"
                :style="item.profit >= 0 ? 'color:red' : 'color:green'"
              >
                ${{ item.profit > 0 ? "+" : ""
                }}{{ item.profit.toLocaleString("en-US") }}
              </b-col>
              <b-col cols="1" class="p-1">
                <b-icon style="color: black" font-scale="0.9" icon="chevron-right"></b-icon>
              </b-col>
            </b-row>
          </div>
        </template>
      </div>
    </div>
    <b-modal centered hide-footer hide-header v-model="editShow">
      <div class="modal-div-edit">
        <div class="form-box">
          <b-form>
            <div class="add-game">
              <b-form-group label="類別：" label-for="radio-button">
                <div class="g-width edit-type">
                  <div class="edit-cash" @click="editForm.type = 'cash'">
                    <b-icon
                      class="edit-icon"
                      font-scale="1.4"
                      :icon="
                        editForm.type === 'cash' ? 'check-square' : 'square'
                      "
                    ></b-icon>現金桌
                  </div>
                  <div class="edit-mtt" @click="editForm.type = 'mtt'">
                    <b-icon
                      class="edit-icon"
                      font-scale="1.4"
                      :icon="
                        editForm.type === 'mtt' ? 'check-square' : 'square'
                      "
                    ></b-icon>錦標賽
                  </div>
                </div>
              </b-form-group>
              <b-form-group id="input-group-cash" label="買入：" label-for="input-cash" required>
                <b-form-input
                  class="g-width edit-input"
                  id="input-cash"
                  v-model="editForm.cashIn"
                  placeholder="必填"
                  required
                  type="number"
                  inputmode="numeric"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="input-group-2"
                :label="form.type === 'cash' ? '出金：' : '獎金：'"
                label-for="input-2"
                required
              >
                <b-form-input
                  class="g-width edit-input"
                  id="input-2"
                  v-model="editForm.cashOut"
                  placeholder="必填"
                  required
                  type="number"
                  inputmode="numeric"
                ></b-form-input>
              </b-form-group>
              <b-form-group id="input-group-3" label="名稱：" label-for="input-3">
                <b-form-input
                  class="g-width edit-input"
                  id="input-3"
                  v-model="editForm.name"
                  placeholder="選填"
                  type="text"
                  :state="editNameState ? undefined : false"
                  aria-describedby="input-live-help input-live-feedback2"
                ></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback2">名稱過長(上限16)</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group id="input-group-4" label="備註：" label-for="input-4">
                <b-form-input
                  class="g-width edit-input"
                  id="input-4"
                  v-model="editForm.comment"
                  placeholder="選填"
                  type="text"
                  :state="editCommentState ? undefined : false"
                  aria-describedby="input-live-help input-live-feedback3"
                ></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback3">備註字數過多(上限200)</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="date">
              <label for="example-datepicker">時間：</label>
              <b-form-datepicker
                id="example-datepicker"
                :date-format-options="{
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                }"
                v-model="editForm.date"
                class="mb-2 g-width edit-input"
                dropright
              ></b-form-datepicker>
            </div>
            <b-button class="save-btn" variant="outline-success" @click="edit()">儲存變更</b-button>
          </b-form>
        </div>
      </div>
    </b-modal>
    <b-modal centered hide-footer hide-header v-model="modalShow">
      <div class="modal-div">
        <div class="modal-type">
          {{
          showContent.type === "cash" ? "現金桌" : "錦標賽"
          }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {{ showContent.date }}
        </div>
        <div class="modal-inout">
          買入：${{
          showContent.cashIn.toLocaleString("en-US")
          }}&nbsp;&nbsp;&nbsp;&nbsp;{{
          showContent.type === "cash" ? "出金：" : "獎金："
          }}${{ showContent.cashOut.toLocaleString("en-US") }}
        </div>
        <div class="modal-comment">{{ showContent.comment }}</div>
        <div class="btn-region">
          <div class="edit-btn" @click="editClick()">
            <b-icon icon="pencil"></b-icon>編輯
          </div>
          <div class="edit-btn" @click="delete_check()">
            <b-icon icon="trash"></b-icon>刪除
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal class="modal-div" centered hide-footer hide-header v-model="dateModalShow">
      <div class="modal-div-d">請選擇起始日期</div>
      <div class="select-range">
        <b-form-datepicker
          :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
          v-model="filter.startDate"
          placeholder="開始日期"
          size="sm"
        ></b-form-datepicker>&nbsp;~&nbsp;
        <b-form-datepicker
          class="end-date"
          :date-format-options="{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              }"
          v-model="filter.endDate"
          placeholder="結束日期"
          size="sm"
          dropright
          dropdown
        ></b-form-datepicker>
        <b-icon
          icon="backspace-fill"
          style="margin-left: 8px"
          aria-hidden="true"
          @click="resetRange"
        ></b-icon>
      </div>
      <div class="ok" @click="handleOk_date">確認</div>
    </b-modal>
    <b-modal class="delete-modal" centered hide-footer hide-header v-model="deleteModalShow">
      <div class="modal-div-d">確認刪除</div>
      <div class="ok" @click="handleOk">確認</div>
    </b-modal>
    <b-modal class="delete-modal" centered hide-footer hide-header v-model="exportShow">
      <div class="modal-div-d" style="margin-bottom: 2rem">複製當前篩選條件的csv格式資料到剪貼簿。</div>
      <div class="ok" @click="sendRecord">複製</div>
    </b-modal>
    <b-navbar type="dark" variant="dark" fixed="bottom">
      <b-navbar-nav>
        <b-nav-item :active="active_add" @click="menu_click('add')">
          <b-icon icon="file-earmark-plus-fill" aria-hidden="true"></b-icon>
          <div class="nav-font">登錄盈利</div>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-nav-item :active="active_report" @click="menu_click('report')">
          <b-icon icon="bar-chart-fill" aria-hidden="true"></b-icon>
          <div class="nav-font">總體報表</div>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import liff from "@line/liff";
import axios from "axios";

export default {
  name: "accounting",
  components: {},
  data() {
    return {
      showDate: true,
      selfSet: false,
      timeBtn: "set",
      modalShow: false,
      dateModalShow: false,
      deleteModalShow: false,
      exportShow: false,
      editShow: false,
      selectIndex: 0,
      showContent: {
        type: "cash",
        name: "",
        cashIn: "",
        cashOut: "",
        comment: "",
        date: ""
      },
      active_add: true,
      active_report: false,
      report_tab: "all",
      form: {
        type: "cash",
        name: "",
        cashIn: "",
        cashOut: "",
        comment: "",
        date: ""
      },
      editForm: {
        id: "",
        type: "cash",
        name: "",
        cashIn: "",
        cashOut: "",
        comment: "",
        date: ""
      },
      today: new Date(),
      report_result: {
        profit: 0,
        winCount: 0,
        winRatio: 0,
        games: 0,
        gainPerGame: 0,
        ROI: 0,
        spend: 0,
        gain: 0
      },
      filter: {
        startDate: "",
        endDate: ""
      },
      liffId: this.$route.query.id,
      liffAccessToken: "",
      showList: [],
      allList: [],
      cashList: [],
      mttList: [],
      list: [
        {
          id: 1,
          type: "cash",
          name: "1234567129AB",
          cashIn: 3400,
          cashOut: 0,
          comment: "一堆魚",
          date: "2023-03-29"
        },
        {
          id: 1,
          type: "cash",
          name: "1234567129AB",
          cashIn: 3400,
          cashOut: 0,
          comment: "一堆魚",
          date: "2023-03-30"
        },
        {
          id: 1,
          type: "cash",
          name: "1234567129AB",
          cashIn: 3400,
          cashOut: 0,
          comment: "一堆魚",
          date: "2023-03-31"
        },
        {
          id: 1,
          type: "cash",
          name: "1234567129AB",
          cashIn: 3400,
          cashOut: 0,
          comment: "一堆魚",
          date: "2023-04-01"
        },
        {
          id: 2,
          type: "cash",
          name: "一二三四五六七八九十",
          cashIn: 3400,
          cashOut: 0,
          comment: "一堆魚",
          date: "2023-04-17"
        },
        {
          id: 3,
          type: "cash",
          name: "廣停家",
          cashIn: 3400,
          cashOut: 5000,
          comment: "123",
          date: "2023-05-17"
        },
        {
          id: 4,
          type: "cash",
          name: "限時",
          cashIn: 3400,
          cashOut: 7600,
          comment: "3400",
          date: "2023-05-17"
        },
        {
          id: 5,
          type: "cash",
          name: "限時",
          cashIn: 6600,
          cashOut: 12300,
          comment: "213123123123123123123123",
          date: "2023-06-17"
        },
        {
          id: 6,
          type: "mtt",
          name: "限時",
          cashIn: 6600,
          cashOut: 12300,
          comment: "限時",
          date: "2023-06-17"
        },
        {
          id: 6,
          type: "mtt",
          name: "限時",
          cashIn: 6600,
          cashOut: 12300,
          comment: "限時",
          date: "2023-06-30"
        },
        {
          id: 6,
          type: "mtt",
          name: "限時",
          cashIn: 6600,
          cashOut: 12300,
          comment: "限時",
          date: "2025-01-05"
        }
      ]
    };
  },
  computed: {
    nameState() {
      return this.form.name.length <= 16 ? true : false;
    },
    editNameState() {
      return this.editForm.name.length <= 16 ? true : false;
    },
    commentState() {
      return this.form.comment.length <= 200 ? true : false;
    },
    editCommentState() {
      return this.editForm.comment.length <= 200 ? true : false;
    }
  },
  mounted() {
    this.liffInit();
    this.form.date = this.filter.endDate = this.today
      .toISOString()
      .split("T")[0];
    this.clickTab("cash");
    document.getElementById("btn-all").style.backgroundColor = "#007bff";
  },
  methods: {
    timeBtnClick(time) {
      document.getElementById("btn-3m").style.backgroundColor = "#6c757d";
      document.getElementById("btn-6m").style.backgroundColor = "#6c757d";
      document.getElementById("btn-all").style.backgroundColor = "#6c757d";
      document.getElementById("btn-set").style.backgroundColor = "#6c757d";
      if (time == "3m") {
        document.getElementById("btn-3m").style.backgroundColor = "#007bff";
      } else if (time == "6m") {
        document.getElementById("btn-6m").style.backgroundColor = "#007bff";
      } else if (time == "all") {
        document.getElementById("btn-all").style.backgroundColor = "#007bff";
      }
      this.timeBtn = time;
      this.clickTabReport(this.report_tab);
    },
    sendRecord() {
      this.recordEvent("liff_accounting_export_data");
      if (this.showList.length === 0) {
        alert(`篩選條件無資料`);
        this.exportShow = false;
        return;
      }
      console.debug(`${JSON.stringify(this.showList)}`);
      let csvData = "日期,比賽類別,買入,出金,名稱,備註\n";
      for (let i = 0; i < this.showList.length; i++) {
        let unit = [];
        unit.push(this.showList[i].date);
        unit.push(this.showList[i].type);
        unit.push(this.showList[i].cashIn);
        unit.push(this.showList[i].cashOut);
        unit.push(this.showList[i].name);
        unit.push(this.showList[i].comment);
        csvData = csvData + unit.join(",") + "\n";
      }
      console.debug(csvData);
      navigator.clipboard
        .writeText(csvData)
        .then(() => {
          this.exportShow = false;
          this.$message({
            message: "內容已複製！",
            type: "success",
            center: true
          });
        })
        .catch(err => {
          alert(`${JSON.stringify(err)}`);
        });
    },
    edit() {
      if (!this.editNameState || !this.editCommentState) {
        return;
      }
      let jsonData = {
        type: this.editForm.type,
        name: this.editForm.name,
        cashIn: parseInt(this.editForm.cashIn),
        cashOut: parseInt(this.editForm.cashOut),
        comment: this.editForm.comment,
        date: this.editForm.date,
        accountingId: this.editForm.id
      };
      axios({
        method: "post",
        url: "/accounting/set",
        data: jsonData,
        headers: {
          "Content-Type": "application/json",
          "Access-Token": this.liffAccessToken
        }
      }).then(res => {
        // console.debug(res);
        //show success
        this.$message({
          message: "牌局編輯成功！！",
          type: "success",
          center: true
        });
        this.editShow = false;
        this.getData();
      });
    },
    onSubmit(event) {
      event.preventDefault();
      // console.debug(JSON.stringify(this.form));
      if (!this.nameState || !this.commentState) {
        return;
      }
      let jsonData = {
        type: this.form.type,
        name: this.form.name,
        cashIn: parseInt(this.form.cashIn),
        cashOut: parseInt(this.form.cashOut),
        comment: this.form.comment,
        date: this.form.date
      };
      axios({
        method: "post",
        url: "/accounting/add",
        data: jsonData,
        headers: {
          "Content-Type": "application/json",
          "Access-Token": this.liffAccessToken
        }
      }).then(res => {
        // console.debug(res);
        //show success
        this.$message({
          message: "牌局登錄成功！！",
          type: "success",
          center: true
        });
        //reset
        this.onReset();
      });
    },
    onReset(event) {
      let tmpType = this.form.type;
      this.form = {
        type: tmpType,
        name: "",
        cashIn: "",
        cashOut: "",
        comment: "",
        date: this.today.toISOString().split("T")[0]
      };
    },
    showComment(index) {
      this.modalShow = !this.modalShow;
      this.showContent = this.showList[index];
      this.selectIndex = index;
    },
    menu_click(e) {
      window.pageYOffset = document.body.scrollTop = document.documentElement.scrollTop = 0;

      if (e == "add") {
        this.active_add = true;
        this.active_report = false;
      }
      if (e == "report") {
        this.getData();
        this.active_add = false;
        this.active_report = true;
      }
    },
    clickTab(tab) {
      this.form.type = tab;
      if (tab === "cash") {
        document.getElementById("tab-name-form-cash").style.border =
          "6px solid #2c3e50";
        document.getElementById("tab-name-form-cash").style.backgroundColor =
          "#2c3e50";
        document.getElementById("tab-name-form-cash").style.color = "white";
        document.getElementById("tab-name-form-mtt").style.border =
          "6px solid cornsilk";
        document.getElementById("tab-name-form-mtt").style.backgroundColor =
          "cornsilk";
        document.getElementById("tab-name-form-mtt").style.color = "#2c3e50";
      } else {
        document.getElementById("tab-name-form-cash").style.border =
          "6px solid cornsilk";
        document.getElementById("tab-name-form-cash").style.backgroundColor =
          "cornsilk";
        document.getElementById("tab-name-form-cash").style.color = "#2c3e50";
        document.getElementById("tab-name-form-mtt").style.border =
          "6px solid #2c3e50";
        document.getElementById("tab-name-form-mtt").style.backgroundColor =
          "#2c3e50";
        document.getElementById("tab-name-form-mtt").style.color = "white";
      }
    },
    clickTabReport(tab) {
      this.report_tab = tab;
      if (tab === "all") {
        this.selectRange(this.allList);
        document.getElementById("tab-name-report-all").style.border =
          "6px solid #2c3e50";
        document.getElementById("tab-name-report-all").style.backgroundColor =
          "#2c3e50";
        document.getElementById("tab-name-report-all").style.color = "white";
        document.getElementById("tab-name-report-cash").style.border =
          "6px solid cornsilk";
        document.getElementById("tab-name-report-cash").style.backgroundColor =
          "cornsilk";
        document.getElementById("tab-name-report-cash").style.color = "#2c3e50";
        document.getElementById("tab-name-report-mtt").style.border =
          "6px solid cornsilk";
        document.getElementById("tab-name-report-mtt").style.backgroundColor =
          "cornsilk";
        document.getElementById("tab-name-report-mtt").style.color = "#2c3e50";
      } else if (tab === "cash") {
        this.selectRange(this.cashList);
        document.getElementById("tab-name-report-all").style.border =
          "6px solid cornsilk";
        document.getElementById("tab-name-report-all").style.backgroundColor =
          "cornsilk";
        document.getElementById("tab-name-report-all").style.color = "#2c3e50";
        document.getElementById("tab-name-report-cash").style.border =
          "6px solid #2c3e50";
        document.getElementById("tab-name-report-cash").style.backgroundColor =
          "#2c3e50";
        document.getElementById("tab-name-report-cash").style.color = "white";
        document.getElementById("tab-name-report-mtt").style.border =
          "6px solid cornsilk";
        document.getElementById("tab-name-report-mtt").style.backgroundColor =
          "cornsilk";
        document.getElementById("tab-name-report-mtt").style.color = "#2c3e50";
      } else {
        this.selectRange(this.mttList);
        document.getElementById("tab-name-report-all").style.border =
          "6px solid cornsilk";
        document.getElementById("tab-name-report-all").style.backgroundColor =
          "cornsilk";
        document.getElementById("tab-name-report-all").style.color = "#2c3e50";
        document.getElementById("tab-name-report-cash").style.border =
          "6px solid cornsilk";
        document.getElementById("tab-name-report-cash").style.backgroundColor =
          "cornsilk";
        document.getElementById("tab-name-report-cash").style.color = "#2c3e50";
        document.getElementById("tab-name-report-mtt").style.border =
          "6px solid #2c3e50";
        document.getElementById("tab-name-report-mtt").style.backgroundColor =
          "#2c3e50";
        document.getElementById("tab-name-report-mtt").style.color = "white";
      }
    },
    getData() {
      axios({
        method: "get",
        url: "/accounting/list",
        headers: {
          "Content-Type": "application/json",
          "Access-Token": this.liffAccessToken
        }
      })
        .then(res => {
          console.debug(res);
          //assign list
          this.allList = res.data.list.filter(e => e.type != "");
          this.cashList = res.data.list.filter(e => e.type === "cash");
          this.mttList = res.data.list.filter(e => e.type === "mtt");
          //first cal
          this.clickTabReport("all");
        })
        .catch(error => {
          alert(`getData error`);
          //test data
          // this.list = [];
          this.allList = this.list.filter(e => e.type != "");
          this.cashList = this.list.filter(e => e.type === "cash");
          this.mttList = this.list.filter(e => e.type === "mtt");
          this.clickTabReport("all");
        });
    },
    selectRange(list) {
      this.showList = list.filter(this.filterRange);
      this.calculate();
    },
    calculate() {
      this.report_result.profit = 0;
      this.report_result.winCount = 0;
      this.report_result.winRatio = 0;
      this.report_result.gainPerGame = 0;
      this.report_result.games = 0;
      this.report_result.ROI = 0;
      this.report_result.spend = 0;
      this.report_result.gain = 0;
      for (let i = 0; i < this.showList.length; i++) {
        this.report_result.games++;
        this.report_result.spend += this.showList[i].cashIn;
        this.report_result.gain += this.showList[i].cashOut;
        this.showList[i].profit =
          this.showList[i].cashOut - this.showList[i].cashIn;
        this.report_result.profit += this.showList[i].profit;
        if (this.showList[i].profit > 0) this.report_result.winCount++;
        // console.debug(this.report_result.winCount);
      }
      this.report_result.ROI = Math.round(
        ((this.report_result.gain - this.report_result.spend) /
          this.report_result.spend +
          Number.EPSILON) *
          100
      );
      this.report_result.winRatio = Math.round(
        (this.report_result.winCount / this.report_result.games +
          Number.EPSILON) *
          100
      );
      this.report_result.gainPerGame = Math.round(
        this.report_result.profit / this.report_result.games + Number.EPSILON
      );
    },
    exportClick() {
      this.exportShow = true;
    },
    delete_check() {
      this.modalShow = false;
      this.deleteModalShow = !this.deleteModalShow;
    },
    editClick() {
      this.modalShow = false;
      this.editForm.id = this.showList[this.selectIndex].id;
      this.editForm.type = this.showList[this.selectIndex].type;
      this.editForm.name = this.showList[this.selectIndex].name;
      this.editForm.cashIn = this.showList[this.selectIndex].cashIn;
      this.editForm.cashOut = this.showList[this.selectIndex].cashOut;
      this.editForm.comment = this.showList[this.selectIndex].comment;
      this.editForm.date = this.showList[this.selectIndex].date;
      this.editShow = !this.editShow;
    },
    handleOk_date() {
      this.dateModalShow = false;
      this.timeBtn = "set";
      document.getElementById("btn-3m").style.backgroundColor = "#6c757d";
      document.getElementById("btn-6m").style.backgroundColor = "#6c757d";
      document.getElementById("btn-all").style.backgroundColor = "#6c757d";
      document.getElementById("btn-set").style.backgroundColor = "#007bff";
      this.clickTabReport(this.report_tab);
    },
    handleOk() {
      this.deleteModalShow = false;
      this.delete_history();
    },
    delete_history() {
      axios({
        method: "delete",
        url: "/accounting/" + this.showList[this.selectIndex].id,
        headers: {
          "Content-Type": "application/json",
          "Access-Token": this.liffAccessToken
        }
      }).then(res => {
        console.debug(res);
        this.$message({
          message: "刪除成功！！",
          type: "success",
          center: true
        });

        this.getData();
      });
    },
    filterRange(e) {
      let day_tmp = e.date.split("-");
      let total =
        parseInt(day_tmp[0]) * 365 +
        parseInt(day_tmp[1]) * 30 +
        parseInt(day_tmp[2]);
      let start, end;
      if (this.timeBtn == "3m") {
        day_tmp = this.today
          .toISOString()
          .split("T")[0]
          .split("-");
        end =
          parseInt(day_tmp[0]) * 365 +
          parseInt(day_tmp[1]) * 30 +
          parseInt(day_tmp[2]);
        start = end - 3 * 30;
      } else if (this.timeBtn == "6m") {
        day_tmp = this.today
          .toISOString()
          .split("T")[0]
          .split("-");
        end =
          parseInt(day_tmp[0]) * 365 +
          parseInt(day_tmp[1]) * 30 +
          parseInt(day_tmp[2]);
        start = end - 6 * 30;
      } else if (this.timeBtn == "all") {
        start = 0;
        end = 800000;
      } else {
        if (this.filter.startDate === "") {
          start = 0;
        } else {
          day_tmp = this.filter.startDate.split("-");
          start =
            parseInt(day_tmp[0]) * 365 +
            parseInt(day_tmp[1]) * 30 +
            parseInt(day_tmp[2]);
        }
        if (this.filter.endDate === "") {
          end = 800000;
        } else {
          day_tmp = this.filter.endDate.split("-");
          end =
            parseInt(day_tmp[0]) * 365 +
            parseInt(day_tmp[1]) * 30 +
            parseInt(day_tmp[2]);
        }
      }
      return start <= total && total <= end ? true : false;
    },
    resetRange() {
      this.filter.startDate = "";
      this.filter.endDate = "";
      this.clickTabReport(this.report_tab);
    },
    liffInit() {
      liff
        .init({
          liffId: this.liffId
        })
        .then(() => {
          this.liffAccessToken = liff.getAccessToken();
          if (!this.liffAccessToken) {
            alert("accessToken error");
          } else {
            this.getData();
            this.recordEvent("liff_accounting");
          }
        })
        .catch(error => {
          alert(`LiffInit error: ${JSON.stringify(error)}`);
        });
    },
    recordEvent(event) {
      axios({
        method: "post",
        url: "/event_record",
        data: {
          event: event
        },
        headers: {
          "Content-Type": "application/json",
          "Access-Token": this.liffAccessToken
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
#tab-name-report-all {
  border: 6px solid #2c3e50;
  background-color: #2c3e50;
  color: white;
}
#tab-name-report-cash {
  border: 6px solid cornsilk;
  background-color: cornsilk;
  color: #2c3e50;
}
#tab-name-report-mtt {
  border: 6px solid cornsilk;
  background-color: cornsilk;
  color: #2c3e50;
}
hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.bg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -999;
}
.bg img {
  min-height: 100%;
  width: 100%;
}
.main {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cus-row {
  margin-top: 2px;
  margin-bottom: 2px;
}
.card--body {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: cornsilk;
  border-radius: 16px;
  margin-top: 2.4rem;
  margin-bottom: 4rem;
  width: 92%;
}
.ipoker {
  position: absolute;
  color: white;
  background-color: black;
  font-size: 12px;
  font-weight: bold;
  border-radius: 6px;
  padding: 1px 4px;
  top: -16px;
  left: 4px;
  font-family: system-ui;
}
.list-region {
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 24rem;
}
.export {
  position: absolute;
  color: white;
  background-color: #0c9207;
  // color: #ffffff00;
  // background-color: #0c920700;
  font-size: 16px;
  font-weight: bold;
  border-radius: 4px;
  padding: 0px 8px;
  top: -30px;
  right: 8px;
  font-family: system-ui;
  text-align: center;
}
.tabs {
  margin-top: 20px;
  // margin-bottom: 20px;
  width: 200px;
}
.report-tabs {
  // width: 200px;
}
.tabs-title {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  font-size: 1.2rem;
}
.tab-item {
  padding: 0px 8px;
  border-radius: 8px;
}
.nav-font {
  font-weight: 600;
}
.form-box {
  width: 90%;
  margin-bottom: 0.8rem;
}
.report {
  width: 95%;
  margin-bottom: 0.8rem;
}
.form-group {
  display: flex;
  justify-content: space-around;
  align-items: baseline;
}
.date {
  display: flex;
  justify-content: space-around;
  align-items: baseline;
}
.date /deep/ .b-calendar {
  padding-bottom: 4rem;
}
.end-date /deep/ .b-calendar {
  padding-bottom: 4rem;
}
.g-width {
  width: 200px;
}
.fixed-bottom {
  width: 100%;
  height: 4rem;
  border-radius: 0.4rem 0.4rem 0 0;
}
.bg-dark {
  background-color: #343a40cc !important;
}
.navbar-expand {
  justify-content: space-evenly;
}
.save-btn {
  width: 100%;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 0.6rem;
  margin-bottom: 0.4rem;
}
.report-item,
.history-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
}
.title {
  font-size: 1.1rem;
  font-weight: 600;
  /* margin-left: 1rem; */
}
.result {
  font-size: 1.1rem;
  font-weight: bold;
  /* margin-right: 1rem; */
}
.col-date {
  font-size: 0.72rem;
}
.col-comment {
  color: black;
  word-wrap: break-word;
  font-size: 0.9rem;
}
.col-profit {
  font-size: 0.9rem;
}
.select-range {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 0.8rem;
  margin-bottom: 2rem;
}
.no-list {
  margin: 4rem 0;
  font-size: 1.2rem;
}
.warn-range {
  color: #dc3545;
  margin: 2rem;
}
.row {
  margin-right: -8px;
  margin-left: -2px;
}
/deep/.modal-content {
  width: 92%;
  left: 4%;
  background-color: #000c;
  color: wheat;
  border-radius: 1rem;
}
.modal-div-edit {
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-div {
  // margin: 1rem;
  word-wrap: break-word;
  text-align: center;
}
.modal-div-d {
  margin: 1rem;
  word-wrap: break-word;
  text-align: center;
}
.modal-comment {
  border: 1px solid wheat;
  margin-top: 4px;
}
.btn-region {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 20px;
}
.edit-btn {
  border: 1px solid wheat;
  border-radius: 12px;
  width: 40%;
}
.delete-modal {
  position: relative;
}
.ok {
  position: absolute;
  bottom: 12px;
  right: 20px;
  font-size: 0.9rem;
  color: silver;
}
.edit-type {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.edit-icon {
  margin-right: 4px;
  margin-top: 4px;
}
.edit-input {
  background-color: rgba(0, 0, 0, 0.8);
  border: 1px solid wheat;
  color: white;
}
.hot-key {
  display: flex;
  justify-content: space-between;
}
.hot-key-btn {
  width: 24%;
  margin-bottom: 4px;
  font-size: 92%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.hot-key-btn-set {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 10px;
}
.active {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/accounting.vue